import React from 'react';
import './PlanAhead.css';

// Import the new image
import teamImage from '../../assets/images/plan-ahead-team.jpg';

const PlanAhead = () => {
  return (
    <section className="plan-ahead-section">
      <div className="plan-ahead-container">
        {/* Left Column: Text Content */}
        <div className="plan-ahead-text-col">
          <h2>CRISHI as your Plan Ahead Team (PAT)</h2>
          <p>
            As your Plan Ahead Team, CRISHI equips you with forward-looking, realistic intelligence to prepare for what's next, not just what's now. We help you model revenue, cash flow, and cost scenarios, and identify tactical and strategic actions across multiple timelines.
          </p>
          <p>
            Our approach is not static; plans that are continuously refined, updated, and strengthened using dynamic market intelligence, so your strategy stays one step ahead.
          </p>
        </div>

        {/* Right Column: Image */}
        <div className="plan-ahead-image-col">
          <img src={teamImage} alt="The CRISHI Plan Ahead Team" />
        </div>
      </div>
    </section>
  );
};

export default PlanAhead;